import { ActionTypes } from "../act_types"
import { ITreeNode } from "../../../utils/tree/interfaces"
import { DropitState } from "../../reducers"

export const toogleNode = (
  node: ITreeNode,
  toogled: boolean,
  treeName: string
): object => ({
  node,
  toogled,
  treeName,
  type: ActionTypes.TOOGLE_TREE_NODE,
})

export const setFilteredData = (
  data: ITreeNode,
  filter = "",
  treeName: string
): object => ({
  data,
  filter,
  treeName,
  type: ActionTypes.SET_FILTERED_DATA,
})

export const loadTree = ({ treeName, rawData, data, filter = "" }: any) => ({
  treeName,
  rawData,
  data,
  filter,
  type: ActionTypes.LOAD_TREE,
})

export const resetTree =
  (treeName: "comTree" | "techTree") =>
  (dispatch: (callback: object) => void, getState: () => DropitState) => {
    const state = getState()
    const data = state.miscellaneous[treeName].data

    dispatch({
      treeName,
      data,
      type: ActionTypes.RESET_TREE,
    })
  }
